import React from 'react'
import PropTypes from 'prop-types'
import './Characters.styles.css'

export default function EmptySlotCard({ onClick }) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClick?.()
    }
  }

  return (
    <div
      className="emptySlotCard"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      aria-label="Crear nuevo shinobi"
      title="Crear nuevo shinobi"
    >
      <div className="emptySlotContent">
        <div className="emptySlotSilhouette" aria-hidden="true">
          <span className="emptySlotSilhouette__head" />
          <span className="emptySlotSilhouette__body" />
        </div>
        <div className="emptySlotText">Crear shinobi</div>
      </div>
    </div>
  )
}

EmptySlotCard.propTypes = {
  onClick: PropTypes.func.isRequired,
}
